export default __webpack_public_path__ + "static/media/primary_sensory_cortex_mask.2bc90695.png";